export default {
  initTree: {
    url: '/purchaser/org/getAll',
    type: 'get',
    parameter: {
      withRoot: 0 // 不需要跟组织
    }
  }
}
